.wrapper {
    position: fixed;
    inset: 0;
    display: grid;
    place-content: center;
    padding: 16px;
    /* animation: slideUp 750ms cubic-bezier(0, 0.72, 0.24, 1.02); */
    animation-delay: 1.1s;
}
@keyframes slideUp {
    from {
        transform: translateY(100%);
    }
    to {
        transform: translateY(0%);
    }
}
.backdrop {
    position: absolute;
    inset: 0;
    background: hsl(0deg 0% 0% / 0.75);
}
.dialog {
    position: relative;
    background: white;
    border-radius: 8px;
    width: 320px;
    padding-bottom: 16px;
}
.closeBtn {
    position: absolute;
    top: 0;
    right: 0;
    padding: 8px;
    color: black;
    cursor: pointer;
    background: transparent;
    border: none;
}
.title {
    border-radius: 8px;
    padding: 8px;
    display: flex;
    background-color: aliceblue;
    width: 100%;
    justify-content: center;
}
.content {
    padding: 8px;
}
